import { RemoteConfigKeys } from './remoteConfigKeys'

export const DEFAULT_REMOTE_CONFIG: Record<RemoteConfigKeys, any> = {
  [RemoteConfigKeys.DISABLE_TICKET_ONLINE]: true,
  [RemoteConfigKeys.ENABLE_ANTIFRAUD]: true,
  [RemoteConfigKeys.ENABLE_CELLPHONE_VALIDATION]: false,
  [RemoteConfigKeys.ENABLE_PIX_PAYMENT_METHOD]: false,
  [RemoteConfigKeys.DEFAULT_PAYMENT_METHOD_CUTOFF_DATE]: '01/01/2022',
}
